export const STREET = 'Admiralitätstraße 60';
export const ZIP = '20459';
export const CITY = 'Hamburg';
export const PHONE = '0800 433 88 77'; // TODO: still used @ legacy footer AND site-data.json
export const PHONE_LINK = '+498004338877';
export const PHONE_ANTRAG = '0800 433 88 77';
export const PHONE_ERROR = '0800 433 88 77';
export const PHONE_INTERNATIONAL_AREA_CODE = '+49';
export const PHONE_LP = '0800 433 88 77';
